import { catchError, map, tap } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DataService } from './../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Observable } from 'rxjs';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { Sms } from '../../model/sms';
import { PagedFilter } from '../../../core/model/paged-filter';
import { SmsFilter } from '../../model/sms-filter';

@Injectable()
export class SmsService extends DataService<Sms> {
  private readonly _defaultFilterFields: string[] = ['createdDateTime', 'phone'];

  constructor(
    httpClient: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(httpClient, config, messageService, Sms, progressBar, 'sms');
  }

  getFilterDefinition(): Observable<PagedFilter<SmsFilter>> {
    return this.client.get<PagedFilter<SmsFilter>>(`${this.endpoint}/filter`).pipe(
      map(res => {
        let result = res;
        result.filter.defaultFields = this._defaultFilterFields;
        if (!result.filter.selectedFields || result.filter.selectedFields.length === 0) {
          result.filter.selectedFields = this._defaultFilterFields;
        }

        return result;
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }

  createSMSLinkedToAgreements(data: any): Observable<any> {
    return this.client.post(`${this.endpoint}/create/lease-agreement-sms`, JSON.stringify(data));
  }

  send(id: string): Observable<any> {
    return this.client
      .put(`${this.endpoint}/send`, {}, { params: new HttpParams().append('id', id) })
      .pipe(tap(() => this.notification.showSuccess('SUCCESS.LETTER_SENT')));
  }

  sendSMSToTenants(sms: any): Observable<any> {
    return this.client.post(`${this.endpoint}/send/tenant-sms`, JSON.stringify(sms));
  }
}
